import React from "react";
import "../node_modules/bootstrap/dist/css/bootstrap.min.css";
import "./App.css";
import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import Footer from "./components/Footer";
import Header from "./components/Header";
import { AuthProvider } from "./context/AuthContext";
import Home from "./pages/Home";
import Login from "./pages/Login";
import PrivateRoute from "./utils/PrivateRoute";
import Forum from "./pages/forum/Forum";
import Profile from "./pages/forum/Profile";
import KalenderPage from "./pages/Kalender";
import { PasswordChangePage } from "./pages/PasswordChange";
import ResetPassword from "./pages/ResetPassword";
import { FortbildungPage } from "./pages/Fortbildung";
import BenutzerverwaltungPage from "./pages/Benutzerverwaltung";
import ArbeitsplanContent from "./components/arbeitsplan/ArbeitsplanContent";
import ArbeitsplanPage from "./pages/Arbeitsplan";
import { KurzubersichtPage } from "./pages/Kurzubersicht";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import Thread from "./pages/forum/Thread";
import Topic from "./pages/forum/Topic";
import Bookmark from "./pages/forum/Bookmark";

const theme = createTheme({
  palette: {
    primary: {
      main: "#1d9538",
    },
    secondary: {
      main: "#1d9538",
    },
  },
});

function App() {
  return (
    <ThemeProvider theme={theme}>
      <Router>
        <AuthProvider>
          <div className="App">
            <Header />

            <Routes>
              <Route path="/login" element={<Login />} />
              <Route path="/reset-password/:uid/:token" element={<ResetPassword />} />

              <Route element={<PrivateRoute />}>
                <Route path="/bookmark" element={<Bookmark />} />
                <Route
                  path="/passwort-aendern"
                  element={<PasswordChangePage />}
                />
                <Route path="/" element={<Home />} />
                <Route path="/threads/:id" element={<Thread />} />
                <Route path="/topic/:id" element={<Topic />} />
                <Route path="/profile/:id" element={<Profile />} />
                <Route path="/forum" element={<Forum />} />
                {/* <Route path="/course" element={<CoursePage />} /> */}
                <Route path="/fortbildung" element={<FortbildungPage />} />
                <Route path="/kurzubersicht" element={<KurzubersichtPage />} />
                <Route path="/arbeitsplan" element={<ArbeitsplanPage />} />
                <Route path="/abwesenheit" element={<KalenderPage />} />
                <Route
                  path="/benutzerverwaltung"
                  element={<BenutzerverwaltungPage />}
                />
              </Route>
            </Routes>
            <Footer />
          </div>
        </AuthProvider>
      </Router>
    </ThemeProvider>
  );
}

export default App;
